import { SITE, PRIVACY_UPDATED } from './siteInfo';
import Fill from './Fill';

// מדיניות הפרטיות (/privacy) - לפי חוק הגנת הפרטיות, התשמ"א-1981 (כולל תיקון 13).
// מתארת איזה מידע נאסף ולמה, בלי פירוט טכני של אופן השמירה. שינוי במה שנאסף → לעדכן כאן ואת PRIVACY_UPDATED.
const PrivacyPolicy = ({ titleStyle, updatedStyle }) => (
  <>
    <h1 style={titleStyle}>מדיניות פרטיות</h1>
    <p style={updatedStyle}>עודכן לאחרונה: {PRIVACY_UPDATED}</p>

    <p>
      הפרטיות שלך חשובה לנו. מסמך זה מסביר איזה מידע נאסף ב"{SITE.name}" ({SITE.url}), למה, עם מי הוא משותף ומה הזכויות שלך.
    </p>

    <h2>1. מידע שנמסר בהרשמה</h2>
    <p>
      בהרשמה נמסרים: שם פרטי ושם משפחה, מספר טלפון (משמש כשם המשתמש לכניסה), האם את/ה תושב/ת כפר חב"ד, וסיסמה.
    </p>
    <p>
      <strong>אין חובה חוקית למסור את המידע</strong>, אולם בלעדיו לא ניתן להירשם ולהשתמש בשירותים שדורשים חשבון.
      אפשר לחפש ולהשוות מחירים גם בלי להירשם.
    </p>

    <h2>2. מידע שנוצר בזמן השימוש</h2>
    <ul>
      <li><strong>פעילות בחשבון:</strong> כניסות ויציאות, חיפושים, מוצרים מועדפים, רשימת קניות ורשימות קודמות, עדכוני מחיר, פידבק ששלחת, ושינויים בפרטים.</li>
      <li><strong>חיפושים:</strong> מה חיפשו וכמה תוצאות נמצאו - גם של גולשים שאינם מחוברים (בלי שיוך לאדם), לצורך "מחפשים הכי הרבה" ושיפור השירות.</li>
      <li><strong>מידע טכני:</strong> כתובת IP, זמן הגישה וסוג הדפדפן, לצורך תפעול ואבטחה.</li>
    </ul>

    <h2>3. למה משתמשים במידע</h2>
    <ul>
      <li>לתת את השירות: התחברות, רשימת קניות, מועדפים, התראות "ירד מחיר", רשימה משותפת לבני הבית.</li>
      <li>לאשר הרשמות ולמנוע שימוש לרעה (למשל עדכוני מחיר כוזבים או ספאם).</li>
      <li>לשפר את האתר - למשל אילו מוצרים מחפשים ואילו חיפושים לא מצאו תוצאות.</li>
      <li>ליצור איתך קשר בעניין החשבון או פנייה ששלחת. לא נשלח הודעות שיווקיות בלי הסכמתך.</li>
    </ul>

    <h2>4. עם מי המידע משותף</h2>
    <ul>
      <li><strong>לא מוכרים ולא מעבירים מידע אישי לגורמי שיווק או פרסום.</strong></li>
      <li>
        <strong>רשימה משותפת:</strong> אם הצטרפת לרשימת קניות משותפת או הזמנת אליה אחרים - שאר המשתתפים רואים את שמך,
        את המוצרים ברשימה ומי הוסיף כל מוצר.
      </li>
      <li><strong>ספקי תשתית:</strong> שרתי האחסון שבהם האתר והמידע פועלים, לצורך הפעלת השירות בלבד.</li>
      <li>
        <strong>אתרי החנויות:</strong> תמונות המוצרים נטענות ישירות משרתי החנויות, ולכן הדפדפן שלך פונה אליהם (ככל אתר שמציג
        תמונה ממקור אחר). לחיצה על "מעבר למוצר" או שיתוף בוואטסאפ מעבירה אותך לשירותים אלה, והם כפופים למדיניות הפרטיות שלהם.
      </li>
      <li>כשהדין מחייב - למשל לפי צו של בית משפט או רשות מוסמכת.</li>
    </ul>

    <h2>5. אבטחת מידע</h2>
    <p>
      אנו נוקטים אמצעים סבירים ומקובלים כדי לשמור על המידע. עם זאת, אין מערכת חסינה לחלוטין, ולא ניתן להבטיח שהמידע
      לא ייחשף בנסיבות חריגות.
    </p>

    <h2>6. כמה זמן נשמר המידע</h2>
    <p>
      פרטי החשבון והפעילות נשמרים כל עוד החשבון פעיל, ולאחר מכן לתקופה הנדרשת לצורכי תפעול, אבטחה או לפי דין.
    </p>

    <h2>7. הזכויות שלך</h2>
    <p>
      לפי חוק הגנת הפרטיות, התשמ"א-1981, את/ה רשאי/ת לעיין במידע שנשמר עליך, לבקש לתקן מידע שאינו נכון, שלם או מעודכן,
      ולבקש למחוק אותו. את הפרטים האישיים אפשר לעדכן בעצמך בעמוד "הפרופיל שלי". לבקשות עיון או תיקון:{' '}
      <Fill value={SITE.contactEmail} />. נשיב בתוך 30 יום.
    </p>
    <p>
      <strong>מחיקת חשבון:</strong> אפשר למחוק את החשבון בעצמך, בכל עת, בתחתית עמוד "הפרופיל שלי". במחיקה נמחקים מיד השם,
      הטלפון והסיסמה, המוצרים המועדפים, רשימת הקניות והרשימות הקודמות (מרשימה משותפת - יוצאים, והיא נשארת לשאר המשתתפים),
      היסטוריית הפעילות, וכל ההתחברויות. חיפושים, עדכוני מחיר ותוכן פידבק שנשלח נשארים באתר <strong>בלי שום קשר אליך</strong>,
      כדי שהמידע שמשתמשים אחרים רואים לא ייפגע.
    </p>

    <h2>8. קטינים</h2>
    <p>השירות מיועד לבני 18 ומעלה. קטינים רשאים להשתמש בו בהסכמת הורה או אפוטרופוס.</p>

    <h2>9. שינויים במדיניות</h2>
    <p>
      נעדכן מסמך זה כשמשתנה האופן שבו המידע נאסף או נשמר. מועד העדכון האחרון מופיע בראש העמוד. בשינוי מהותי נודיע על כך באתר.
    </p>

    <h2>10. יצירת קשר</h2>
    <p>
      שאלות בנושא פרטיות: <Fill value={SITE.contactEmail} />
      {SITE.contactPhone ? <>, טלפון {SITE.contactPhone}</> : null}.
    </p>
  </>
);

export default PrivacyPolicy;
